<template>
  <div class="row">
    <form class="user-reset-form" @submit="handleSubmit">
      <label for="user-id"> Reset User (User ID or user email) </label>
      <input
        id="user-id"
        v-model="userID"
        class="userid-input"
        autofocus="true"
        type="text"
        placeholder="Enter user ID or email"
      />
      <button
        class="p-3 shadow-md px-12 rounded-full mt-6 border-none text-white font-bold bg-red"
      >
        Reset User
      </button>
    </form>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      userID: "",
      cohortID: "",
      // //
      cohortList: [],
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}cohorts/`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    })
      .then(res => {
        this.cohortList = res.data.items
      })
      .catch(err =>
        this.$noty.error(
          `Something went wrong while fething data from server, server responded with: ${err}`
        )
      )
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.removeUserFromCohort()
    },
    async removeUserFromCohort() {
      // https://localhost:9991/api/v1/admin/reset_user_by_id/-LHAG8oY7K0G2kVYHXmM

      const v = await this.$swal({
        text: `Please check branch! Are you sure you want to reset this user on ${window.location.hostname}?`,
        buttons: {
          cancel: true,
          confirm: {
            text: "Yes",
            value: true,
          },
        },
      })
      document.querySelector("#user-id").focus()
      if (!v) {
        return
      }

      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/reset_user_by_id/${this.userID}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$noty.success("Successfully reset user.")
        })
        .catch(() => {
          this.$noty.error("Not able to archive user record in API server")
        })
    },
  },
}
</script>

<style scoped>
.user-reset-form {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
  text-align: center;
}
.user-reset-form > input {
  padding: 10px;
  border: 2px solid grey;
  border-radius: 5px;
}
.user-reset-form > input:focus {
  border: 2px solid green;
}
.user-reset-form > label {
  font-size: 18px;
  cursor: pointer;
}
</style>
